import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from "i18next";
import { initReactI18next } from 'react-i18next';

import en from "./locales/en.json";
import ja from "./locales/ja.json";
import zhHant from "./locales/zh-hant.json";
// import zhHans from "./locales/zh-hans.json";

const DEF_LANG = 'en';
const ENABLE_LANG = ['en', 'ja', 'zh', 'zh-hant'];

const fallbackLng = () => {
    // browser lang
    let lang = navigator.language;
    if (lang && lang.length >= 2) {
        lang = lang.substr(0, 2);
        if (ENABLE_LANG.includes(lang)){
            return lang;
        }
    }
    return DEF_LANG;
}

i18n.use(LanguageDetector) //嗅探当前浏览器语言
.use(initReactI18next) //init i18next
.init({
  // 引入资源文件
  resources: {
    'en': { translation: en },
    'ja':{ translation: ja },
    'zh': { translation: zhHant },
    'zh-hant': { translation: zhHant },
    // 'zhHans': { translation: zhHans }
  },

  // 预加载
  preload: ENABLE_LANG,

  // 默认语言, 先获取浏览器语言，如果失败或者不支持则使用en
  fallbackLng: fallbackLng(),

  // 语言嗅探
  detection: {
    lookupQuerystring: 'lang',
    order: ['querystring', 'localStorage', 'cookie']
  },

  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

// 设置为浏览器语言
// i18n.changeLanguage(browserLang())

export default i18n;